module.exports = __webpack_public_path__ + "img/pagemakerpro-logo-dark.e73b0a18.png";